import styled from 'styled-components';

export const AreaBack = styled.div`
  @media (min-width: 768px) {
    padding: 0rem 8rem 0rem 8rem;
  }
`;

export const Background = styled.div`
  position: fixed;
  margin-top: -10px;
  padding-top: 50px;
  background-color: white;
  height: 100vh;
  overflow-y: scroll;
  width: 100%;
  @media (max-width: 768px) {
    height: 100vh;
    padding-bottom: 120px;
    position: relative;
  }
`;

export const BackIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
  cursor: pointer;

  @media (max-width: 768px) {
    margin: 2rem 1rem 0rem 0rem;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  //position: relative !important;
  padding: 0 0 20px 20px;
  background-color: white;
  @media (max-width: 770px) {
    padding: 0;
  }
`;
